const actions = {
  async errorJoiningRoom({dispatch}) {
    dispatch('popups/show/error/custom', 'joining this Room', {root: true})
  },
  async errorLeavingRoom({dispatch}) {
    dispatch('popups/show/error/custom', 'leaving this Room', {root: true})
  },
  async errorCreatingRoom({dispatch}) {
    dispatch('popups/show/error/custom', 'creating a new Room', {root: true})
  },
  async errorDeletingRoom({dispatch}) {
    dispatch('popups/show/error/deleting', 'The room', {root: true})
  },
  async successDeletingRoom({dispatch}, roomName) {
    dispatch('popups/show/success',{
      message: `${roomName} <br> will be removed <br> after all participants have left.`,
      timeout: 7000
    }, {root: true})
  },
  async errorUpdatingRoomTitle({dispatch}) {
    dispatch('popups/show/error/updating', 'Room title', {root: true})
  },
  async successUpdatingRoomTitle({dispatch}) {
    dispatch('popups/show/success/updating', 'Room title', {root: true})
  },
  async errorCustomisingRoom({dispatch}) {
    dispatch('popups/show/error/custom', 'customising your Room', {root: true})
  },
  // LOCATION SUCCESS popups ---------------------------------------------------
  async successCustomisingRoom({dispatch},roomName) {
    dispatch('popups/show/success',{
      message: `Your changes to '${roomName}' have been saved.`,
      timeout: 7000
    }, {root: true})
  },

  //permissions
  async confirmMakeCohost({dispatch}, {name, callback}) {
    dispatch('popups/show/confirm',{
      message: `Make co-host`,
      description: `Are you sure you want to make <br> ${name} a co-host? <br/><br/>This will give them admin status for this room.`,
      buttons: [
        {
          name: 'Make co-host',
          id: 'save',
          function: callback,
          colour: 'green'
        },
        {
          name: "Cancel",
          id: 'back',
          function: 'close',
        },
      ],
    }, {root: true})
  },

  //portals/jump spaces ------------------------------------------------------------------------------------------
  //error entering area/space portal
  async errorEnteringSpacePortal({dispatch}) {
    dispatch('popups/show/error',{
      message: 'There was an error entering this Portal, you may not have access to this Space.',
    }, {root: true})
  },
  async errorDeletingSpacePortal({dispatch}) {
    dispatch('popups/show/error/deleting', 'The Portal', {root: true})
  },
  async successDeletingSpacePortal({dispatch}, roomName) {
    dispatch('popups/show/success/removing', roomName, {root: true})
  },
  async errorCreatingJumpSpace({dispatch}) {
    dispatch('popups/show/error/custom', 'creating a new Room Portal', {root: true})
  },

  // LOCATION CONFIRM popups -------------------------------------------
  async confirmSwitchRoom({rootGetters,dispatch},callback) {
    dispatch('popups/show/confirm',{
      message: `You are currently in ${rootGetters.getCurrentUsersRoomName}, are you sure you want to switch Room?`,
      buttons: [
        {
          name: 'Switch Room',
          id: 'change-room',
          colour: 'green',

          function: callback,
        },
        {
          name: 'Cancel',
          id: 'cancel',

          function: () => dispatch('updateIfEnterRoomClicked', false)
        }
      ]
    }, {root: true})
  },
  async confirmCreateRoomWhenInMeeting({rootGetters,dispatch},callback) {
    dispatch('popups/show/confirm',{
      message: `You are currently in ${rootGetters.getCurrentUsersRoomName}, are you sure you want to create a new room?`,
      buttons: [
        {
          name: 'Create a new room',
          id: 'create-room',
          colour: 'green',

          function: callback,
        },
        {
          name: 'Cancel',
          id: 'cancel',

          function: 'close'
        }
      ]
    }, {root: true})
  },
};

export default {
  actions
};
